<template>
  <div v-parallax-fit="parallax" class="slide-sticker" id="slidesticker-1">
    <img src="/themes/rise-theme/dist/images/estate/character-view/henry/07_legalAd.png">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 12000,
          end: 13000,
          fromStyle: { transform: 'scale(0) rotate(0deg) translateX(0%) translateY(0%)' },
          toStyle: { transform: 'scale(1) rotate(360deg) translateX(0%) translateY(0%)' },
          easing: 'linear'
        },
        {
          start: 13000,
          end: 13500,
          fromStyle: { transform: 'scale(1) rotate(360deg) translateX(0%) translateY(0%)' },
          toStyle: { transform: 'scale(2) rotate(360deg) translateX(50%) translateY(0%)' },
          easing: 'linear'
        },
        {
          start: 13600,
          end: 15000,
          fromStyle: { transform: 'scale(2) rotate(360deg) translateX(50%) translateY(0%)' },
          toStyle: { transform: 'scale(2) rotate(360deg) translateX(50%) translateY(450%)' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/henry/evidence/5.png',
          url: 'https://www.trla.org/',
          link_title: {
			'en': "Texas RioGrande Legal Aid",
			'es': 'Asistencia Legal de Texas RioGrande'
		  },
        }
      ],
      text: {
		'en': '"TRLA attorneys specialize in more than 45 practice areas, including family, employment, foreclosure, bankruptcy, subsidized housing, farmworker, civil rights, and environmental law."',
		'es': '"Los abogados de TRLA se especializan en más de 45 áreas de práctica, que incluyen familia, empleo, ejecución hipotecaria, bancarrota, vivienda subsidiada, trabajadores agrícolas, derechos civiles y derecho ambiental".'
	  }
    };
    const text = {
		'en': 'Founded in 1970 to represent Texas farmworkers, TRLA has grown into the nation’s second largest legal aid provider and the largest in Texas. TRLA provides free civil legal services to residents in 68 Southwest Texas counties, and represents migrant and seasonal farm workers throughout the state and in six other southern states.',
		'es': 'Fundada en 1970 para representar a los trabajadores agrícolas de Texas, TRLA se ha convertido en el segundo proveedor de asistencia legal más grande del país y el más grande de Texas. TRLA brinda servicios legales civiles gratuitos a los residentes en 68 condados del suroeste de Texas y representa a los trabajadores agrícolas migrantes y de temporada en todo el estado y en otros seis estados del sur.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'scale(2) rotate(360deg) translateX(50%) translateY(0%)') {
          self.$evidence.value = JSON.stringify(evidence);
          self.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#slidesticker-1'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
}
</script>

<style lang="scss" scoped>
.slide-sticker {
  max-width: 100px;
  position: absolute;
  top: 34.4%;
  left: 36%;
  transition: all 0.1s linear;
}

@media screen and (max-width: 1280px) {
  .slide-sticker {
    max-width: 70px;
    left: 35%;
  }
}

@media screen and (max-width: 650px) {
  .slide-sticker {
    max-width: 45px;
  }
}
</style>
